import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import { DateCell, TextCell } from "@tfg/ui"
import { useMemo } from "react"

import { AdminResponses } from "@tfg/types/endpoints/admin"

export const useGetExportColumns =
  (): ColumnDef<AdminResponses.BouncedEmails>[] => {
    const columnHelper = createColumnHelper<AdminResponses.BouncedEmails>()

    return useMemo<ColumnDef<AdminResponses.BouncedEmails, any>[]>(
      () => [
        columnHelper.accessor("createdAt", {
          enableSorting: false,
          header: "Date",
          cell: ({ getValue }) => <DateCell date={getValue()} />,
        }),
        columnHelper.accessor("inviterOrganization", {
          enableSorting: false,
          header: "Inviter Company",
          cell: ({ getValue }) => <TextCell value={getValue()} />,
        }),
        columnHelper.accessor("inviterEmail", {
          enableSorting: false,
          header: "Inviter Email",
          cell: ({ getValue }) => <TextCell value={getValue()} />,
        }),
        columnHelper.accessor("event", {
          enableSorting: false,
          header: "Event",
          cell: ({ getValue }) => <TextCell value={getValue()} />,
        }),
        columnHelper.accessor("supplierEmail", {
          enableSorting: false,
          header: "Supplier Email",
          cell: ({ getValue }) => <TextCell value={getValue()} />,
        }),
      ],
      [columnHelper]
    )
  }
